import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import { AgentCreateTabType } from '@d-id/types';
import styled from '@emotion/styled';
import { Tab, Tabs } from '@mui/material';
import { observer } from 'mobx-react-lite';

const CustomTabs = styled(Tabs)`
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-around;

    & .Mui-selected {
        color: ${({ theme }) => theme.colors.primary.main} !important;
    }

    & .MuiTabs-flexContainer {
        position: relative;
        height: 100%;
    }

    & .MuiTabs-indicator {
        z-index: 2;
        background-color: ${({ theme }) => theme.colors.primary.main} !important;
    }
`;

const CustomTab = styled(Tab)<{ isError?: boolean }>`
    text-transform: none;
    color: ${({ isError, theme }) => (isError ? theme.colors.error.main : theme.colors.black[550])} !important;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.6rem;
    color: ${theme.colors.black[600]};
`;

interface Props {
    onChange: (tab: number) => void;
    tab: number;
    disabled: boolean;
}

export const PresentersTabs = observer(({ tab, onChange, disabled }: Props) => {
    const agentEditorStore = useAgentEditorStore();

    const isError = (tab: AgentCreateTabType) => agentEditorStore.errorTabs.includes(tab);

    return (
        <CustomTabs
            TabIndicatorProps={{ style: { backgroundColor: '#242625' } }}
            value={tab}
            onChange={(_e, v) => onChange(v)}
            aria-label="Tabs for presenters select mode">
            <CustomTab disabled={disabled} label="Appearance" isError={isError(AgentCreateTabType.Appearance)} />
            <CustomTab disabled={disabled} label="Agent details" isError={isError(AgentCreateTabType.Details)} />
            <CustomTab disabled={false} label="Knowledge sources" isError={isError(AgentCreateTabType.KnowledgeBase)} />
            <CustomTab disabled={false} label="Chat settings" isError={isError(AgentCreateTabType.ChatSettings)} />
        </CustomTabs>
    );
});
